import { useState } from "react";
import supabase from "../supabase";
import { CATEGORIES } from "./categories";


function Fact({ fact, setFacts }) {
    let [ isUpdating, setIsUpdating ] = useState(false)
    let isDisputed = (fact.votesInteresting + fact.votesMindblowing) < fact.votesFalse

    async function handleVote(columnName) {
        setIsUpdating(true)

        const { data: updatedFact, error } = await supabase
        .from('facts')
        .update({ [columnName]: fact[columnName] + 1 })
        .eq("id", fact.id)
        .select()

        setIsUpdating(false)

        if (!error) {
            console.log(updatedFact)
            setFacts((facts)=>facts.map((f) => (f.id === fact.id ? updatedFact[0] : f)))
        } else {
            console.log("Error updating", error)
        }
    }

    return (
        <>
            {/* <p>Fact</p> */}
            <li className="fact">
                <div className="fact-content">
                    {isDisputed ? <span className="disputed">[⛔️ DISPUTED]</span> : null }
                    <p>{fact.text}
                    <a className="link-source" href={fact.source} rel="noreferrer" target="_blank"> (Source) </a>
                    </p>
                    <span className="tag" style={{backgroundColor: CATEGORIES.find((category)=>category.name===fact.category).color}}>[{fact.category}]</span>
                </div>
                <div className="vote-buttons">
                    <button className="vote-button" onClick={()=>handleVote("votesInteresting")} disabled={isUpdating}>
                         👍 <strong>{fact.votesInteresting}</strong>
                    </button>
                    <button className="vote-button" onClick={()=>handleVote("votesMindblowing")} disabled={isUpdating}>
                         🤯 <strong>{fact.votesMindblowing}</strong>
                    </button>
                    <button className="vote-button" onClick={()=>handleVote("votesFalse")} disabled={isUpdating}>
                         ⛔️ <strong>{fact.votesFalse}</strong>
                    </button>
                </div>
            </li>
        </>
    );
}
  
export default Fact;